
import React, {  useEffect, useState } from "react";
import { Layout, Menu, Drawer } from "antd";
import { HiShoppingBag } from "react-icons/hi";
import { BsPersonCircle } from "react-icons/bs";
import { TbDashboard } from "react-icons/tb";
import { CgSupport } from "react-icons/cg";
import { FiLogOut } from "react-icons/fi";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import MyOrders from "./MyOrders/MyOrders";
import MyProfile from "./MyProfile/MyProfile";
import Address from "./MyProfile/MyAddress";
import Support from "./Support/Support";
import Dashboard from "../Dashboard/Dashboard";
import { useAuth } from "../AuthContext/AuthContext";
import { useNavigate } from "react-router-dom";
import MobileTabs from "./MobileTabs/MobileTabs";
import { useNotification } from "../Toast/Notification";


const { Content, Sider } = Layout;

const Client: React.FC = () => {
  const [selectedKey, setSelectedKey] = useState<string>("1");
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
  const [isDrawerVisible, setIsDrawerVisible] = useState<boolean>(false);
  const { user, logout } = useAuth();
  const { notify } = useNotification();
  const navigate = useNavigate();

  const renderContent = () => {
    switch (selectedKey) {
      case "1":
        return <MyOrders />;
      case "2-1":
        return <MyProfile />;
      case "2-2":
        return <Address />;
      case "3":
        return <Support />;
      case "4":
        return <Dashboard />;
      default:
        return <MyOrders />;
    }
  };

  const handleMenuClick = async (e: { key: string }) => {
    setSelectedKey(e.key);
    if (e.key === "3") {
      window.open("/support", "_blank");
    } else if (e.key === "4") {
      navigate("/dashboard");
    } else if (e.key === "logout") {
      await logout();
      notify("User has successfully logged out", "success")
      navigate("/");
    }
  };

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const toggleDrawer = () => {
    setIsDrawerVisible(!isDrawerVisible);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderMenu = () => (
    <Menu
      mode="inline"
      defaultSelectedKeys={["1"]}
      selectedKeys={[selectedKey]}
      onClick={handleMenuClick}
      className="bg-transparent border-none text-[#75A7AD]"
    >
      {user && (user.role === "admin" || user.role === "super_admin") && (
        <Menu.Item
          key="4"
          icon={<TbDashboard size={25} />}
          className="border-none text-[#75A7AD]"
        >
          Admin Dashboard
        </Menu.Item>
      )}
      <Menu.Item
        key="1"
        icon={<HiShoppingBag size={25} />}
        className="border-none text-[#75A7AD]"
      >
        My Orders
      </Menu.Item>
      <Menu.SubMenu
        key="2"
        icon={<BsPersonCircle size={25} />}
        title={<span style={{ color: "#75A7AD" }}>Personal Details</span>}
        className="border-none"
      >
        <Menu.Item key="2-1" style={{ color: "#75A7AD" }}>
          My Profile
        </Menu.Item>
        <Menu.Item key="2-2" style={{ color: "#75A7AD" }}>
          My Address
        </Menu.Item>
      </Menu.SubMenu>
      <Menu.Item
        key="3"
        icon={<CgSupport size={25} />}
        className="border-none text-[#75A7AD]"
      >
        Support
      </Menu.Item>
      <Menu.Item
        key="logout"
        icon={<FiLogOut size={25} />}
        className="border-none text-[#75A7AD]"
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
    
   <Navbar/>
      <div className="bg-white shadow-sm pt-[15%]">
        <Layout className="bg-white">
          {windowWidth > 1024 ? (
            <Sider
              style={{ backgroundColor: "transparent", borderRadius: "6%" }}
              width={320}
              className="bg-transparent shadow-lg h-[550px] ml-6 hidden lg:block"
            >
              {renderMenu()}
            </Sider>
          ) : (
            <div className="lg:hidden">
              <MobileTabs />
            </div>
          )}

          <Layout className=" bg-transparent">
            <Content className=" min-h-[280px] bg-transparent">
              <div className=" rounded bg-transparent">{renderContent()}</div>
            </Content>
          </Layout>
          <Drawer
            title="Menu"
            placement="left"
            onClose={toggleDrawer}
            visible={isDrawerVisible}
            width={320}
            bodyStyle={{ padding: 0 }}
          >
            {renderMenu()}
          </Drawer>
        </Layout>
        <Footer />
      </div>
    </div>
  );
};

export default Client;